/*=========================================================================================
  File Name: module-supplier-mutations.js
  Description: Supplier Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */
export default {
	updateUserSetup(state, res) {
		if (res && Object.keys(res).length > 0) {
			state.UserSetup = res;
		}
	}
};
